import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Formats from "./pages/Formats";
import Servizi from "./pages/Servizi";
import Eventi from "./pages/Eventi";
import Galleria from "./pages/Galleria";
import Contatti from "./pages/Contatti";
import Careers from "./pages/Careers";
import Privacy from "./pages/Privacy";
import Cookie from "./pages/Cookie";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { LangProvider } from "./contexts/LangContext";
import { AuthProvider } from "./contexts/AuthContext";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/format" element={<Formats />} />
                <Route path="/servizi" element={<Servizi />} />
                <Route path="/eventi" element={<Eventi />} />
                <Route path="/galleria" element={<Galleria />} />
                <Route path="/contatti" element={<Contatti />} />
                <Route path="/lavora-con-noi" element={<Careers />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/cookie" element={<Cookie />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#141414",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 0,
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
